'use client'

import { convertMultilingualData } from '@/lib/translation/multilingual'
import { DEFAULT_LANGUAGE } from '@/lib/translation/utils'
import { HeaderProps } from '@/lib/types/headerProps'
import dynamic from 'next/dynamic'

const DynamicHeader = dynamic(() => import('./DynamicHeader'), {
  ssr: false,
  loading: () => null
})

export function DynamicHeaderWrapper(props: Readonly<HeaderProps>) {
  const { lang = DEFAULT_LANGUAGE, data, ...rest } = props

  const convertedData = convertMultilingualData(data, lang)

  const enhancedData = {
    ...convertedData,
    language: lang
  }

  return <DynamicHeader {...rest} data={enhancedData} lang={lang} />
}
